export enum ListItemType {
  TRANSACTION = 'TRANSACTION',
  CONTRACT = 'CONTRACT',
  ACT = 'ACT',
  COUNTERPARTY = 'COUNTERPARTY',
  STREET = 'STREET',
  MANAGER = 'MANAGER',
  CONTACT = 'CONTACT',
  ASSOCIATION = 'ASSOCIATION',
  PROJECT = 'PROJECT',
  TASK = 'TASK',
  LEAD = 'LEAD',
}
